import React, { useState } from 'react'

import useFetch from 'hooks/useFetch'

import { Container, ContentHeader, LoadingFeedback, Page } from 'components'
import { PdcaCycleForm } from './components'

import * as service from 'service'

const PdcaCycleEdit = ({ match }) => {
  const { pdcaCycleId, pdcaId } = match.params
  const [loading, setLoading] = useState(false)

  const { response, isLoading, refresh } = useFetch(
    service.dponet.pdca.showCycles,
    { pdcaId, pdcaCycleId },
    [pdcaId, pdcaCycleId],
  )

  const dataPdcaCicle = response?.data?.monitoringManagementPdcaCycle

  return (
    <Page title="Editar ciclo de PDCA">
      <Container maxWidth={false}>
        <LoadingFeedback open={loading || isLoading} />
        <ContentHeader title="Editar ciclo de PDCA" />
        {!isLoading && (
          <PdcaCycleForm
            setLoading={setLoading}
            dataPdcaCicle={dataPdcaCicle}
            refresh={refresh}
            mode="edit"
            pdcaId={pdcaId}
          />
        )}
      </Container>
    </Page>
  )
}

export default PdcaCycleEdit
